
export default {
  name: "CardViewESOMember",
  data() {
    return {
      show: false,
      actionMenus: [
        { title: this.$t("edit"), action: 1, icon: "mdi-pencil" },
        { title: this.$t("delete"), action: 2, icon: "mdi-delete" },
      ],
    };
  },
  props: {
    to: { type: String, default: "" },
    name: String,
    role: String,
    status: String,
    thumbnail: { type: String, default: "/images/default-image.png" },
    showActions: { type: Boolean, default: false },
    memberId: Number,
  },
  computed: {
    ownershipLabel() {
      return this.role ? this.role : this.$t("n_a");
    },
  },
  mounted() {},

  methods: {
    deleteMember() {
      this.$emit("delete-member", {
        isReview: !!this.status,
        memberId: this.memberId,
      });
    },
  },
};
